import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const repaymentPlanTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "repaymentPlan",
};

export interface IRepaymentPlanTranslations {
  repaymentPlan: typeof en;
}
